<template>
  <div class="col-4 article-preview">
    <div class="d-flex">
      <div class="media">
        <div class="media-body">
          <div class="h2 preview-header">
            {{ $t("label.preview") }}
          </div>
          <div class="preview-sub-header">
            {{ $t("label.mobile_device") }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="mobile-box">
        <mobile-box :content="content" :cover="coverUrl"></mobile-box>
      </div>
    </div>
  </div>
</template>

<script>
import MobileBox from "@/components/admin/view/article/create/MobileBox";

export default {
  props: ["coverUrl", "content"],
  components: {
    MobileBox
  },
  data() {
    return {
      articleId: this.$route.params.articleId,
      articleType: this.$route.params.articleType
    };
  }
};
</script>

<style scoped>
.article-preview {
  padding-top: 16px;
}
.preview-sub-header {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/PreviewPanel.vue